import { Title, Section } from "@vshp/ui-components";
import { Roboto } from "next/font/google";

const RobotoFont = Roboto({
  weight: ["900"],
  style: ["normal"],
  subsets: ["latin"],
});

function Career({ salary, vacancies }) {
  return (
    <Section>
      <style jsx global>{`
        .career-stat__num {
          font-family: ${RobotoFont.style.fontFamily};
        }
      `}</style>
      <Title type="h2">ВАША КАРЬЕРА ПО ОКОНЧАНИИ ОБУЧЕНИЯ</Title>
      <div className="career-stat">
        <div className="career-stat__col">
          <div className="career-stat__num">{vacancies}</div>
          <div className="career-stat__title t-h3">Компаний прямо сейчас ищут выпускников этого направления</div>
        </div>
        <div className="career-stat__col">
          <div className="career-stat__num">{salary}</div>
          <div className="career-stat__title t-h3">Средняя ежемесячная заработная плата выпускников этого направления</div>
        </div>
      </div>
    </Section>
  );
}

export default Career;
